import React, { useCallback, useState } from 'react';
import { ChevronDown } from 'cards/components/common/SvgIcons';

import {
  Filter,
  FilterHeader,
  FilterTitle,
  FilterSelectedOptions,
  FilterLabel,
  FilterExpendIndentify,
  FilterContent,
} from './FilterBase.style';

export { FilterOption } from './FilterBase.style';

interface FilterBaseProps {
  filterLabel: string;
  filterCount?: number;
  filterSelectedOptions?: string;
  activeFilter: string | null;
}

export const FilterBase: React.FC<FilterBaseProps> = ({
  filterLabel,
  filterCount,
  filterSelectedOptions,
  activeFilter,
  children,
}) => {
  const [isExpended, setExpended] = useState(activeFilter === filterLabel);
  const toggle = () => setExpended(currentState => !currentState);

  const filterRef = useCallback(
    current => {
      if (current && activeFilter === filterLabel) {
        current.scrollIntoView();
      }
    },
    [activeFilter, filterLabel]
  );

  return (
    <Filter ref={filterRef}>
      <FilterHeader>
        <FilterTitle onClick={toggle}>
          <FilterLabel>
            {filterLabel} {filterCount ? `(${filterCount})` : null}
          </FilterLabel>
          <FilterExpendIndentify isExpended={isExpended}>
            <ChevronDown width={24} height={24} />
          </FilterExpendIndentify>
        </FilterTitle>
        {filterSelectedOptions ? (
          <FilterSelectedOptions>{filterSelectedOptions} </FilterSelectedOptions>
        ) : null}
      </FilterHeader>
      {isExpended ? <FilterContent>{children}</FilterContent> : null}
    </Filter>
  );
};
